module.exports = __webpack_public_path__ + "img/emoji-laughing-fill.e2b29301.svg";